import React, { useState } from 'react';
import {
  Box,
  Flex,
  Text,
  Avatar,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
  useDisclosure,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  VStack,
  Image,
  HStack,
  Badge,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Divider,
  Button
} from '@chakra-ui/react';
import { SearchIcon, BellIcon, CloseIcon, SettingsIcon } from '@chakra-ui/icons';
import { FaStore, FaLanguage } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import '../MobileHeader.css';
import { useLanguage } from '../context/LanguageContext';
import { useTranslation } from '../translations/useTranslation';
import logo from "../Assets/logo.png";

const MobileHeader = () => {
  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isOpen: isSettingsOpen, onOpen: onSettingsOpen, onClose: onSettingsClose } = useDisclosure();
  const { language, changeLanguage, availableLanguages } = useLanguage();
  const { t } = useTranslation();
  
  const name = localStorage.getItem("authname") || "Guest";
  const picture = localStorage.getItem("authpicture") || "https://bit.ly/broken-link";
  const isAuthenticated = localStorage.getItem("authToken") ? true : false;
  
  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      const newUrl = `/results?query=${encodeURIComponent(searchQuery)}`;
      window.location.href = newUrl;
    }
  };
  
  const toggleSearch = () => {
    setShowSearch(!showSearch);
  };
  
  return (
    <Box className="mobile-header">
      {showSearch ? (
        <Flex w="100%" align="center" p={2}>
          <form onSubmit={handleSearchSubmit} style={{ width: '100%' }}>
            <InputGroup size="sm">
              <Input 
                placeholder="Search products..." 
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                autoFocus
                borderRadius="full"
                bg="white"
                boxShadow="sm"
                size="sm"
                py={1}
              />
              <InputRightElement>
                <IconButton
                  aria-label="Close search"
                  icon={<CloseIcon />}
                  size="xs"
                  variant="ghost"
                  onClick={toggleSearch}
                />
              </InputRightElement>
            </InputGroup>
          </form>
        </Flex>
      ) : (
        <Flex justify="space-between" align="center" p={2}>
          <HStack className='on-top' spacing={2}>
            <Link to="/">
              <img style={{ width: '40px' }} src={logo} alt="Logo" />
            </Link>
            <Box className="welcome-text">
              <Text fontSize="2xs" color="gray.500" lineHeight="1">Welcome</Text>
              <Text fontWeight="medium" fontSize="xs" lineHeight="1">
                {name.split(' ')[0]} 👋
              </Text>
            </Box>
          </HStack>
          
          <HStack spacing={2}>
            <IconButton
              aria-label="Search"
              icon={<SearchIcon />}
              variant="ghost"
              onClick={toggleSearch}
              colorScheme="green"
              size="sm"
            />
            
            {/* <Box position="relative">
              <IconButton
                aria-label="Notifications"
                icon={<BellIcon />}
                variant="ghost"
                onClick={onOpen}
                colorScheme="green"
                size="sm"
              />
              {isAuthenticated && (
                <Badge 
                  position="absolute" 
                  top="-2px" 
                  right="-2px" 
                  bg="red.500" 
                  borderRadius="full" 
                  boxSize="2"
                />
              )}
            </Box> */}
            
            <IconButton
              aria-label={t('settings')}
              icon={<SettingsIcon />}
              variant="ghost"
              onClick={onSettingsOpen}
              colorScheme="green"
              size="sm"
            />
            
            <Avatar size="xs" src={picture} />
          </HStack>
        </Flex>
      )}
      
      {/* Notifications Drawer */}
      <Drawer placement="right" onClose={onClose} isOpen={isOpen}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerHeader borderBottomWidth="1px" fontSize="md" py={3}>{t('notifications')}</DrawerHeader>
          <DrawerBody>
            <VStack align="stretch" spacing={3}>
              {isAuthenticated ? (
                <>
                  <Box p={3} shadow="sm" borderWidth="1px" borderRadius="md" bg="white">
                    <Text fontWeight="bold" fontSize="sm">{t('newMessage')}</Text>
                    <Text fontSize="xs">{t('newMessageFrom')}</Text>
                    <Text fontSize="2xs" color="gray.500" mt={1}>2 {t('hoursAgo')}</Text>
                  </Box>
                  <Box p={3} shadow="sm" borderWidth="1px" borderRadius="md" bg="white">
                    <Text fontWeight="bold" fontSize="sm">{t('priceAlert')}</Text>
                    <Text fontSize="xs">{t('priceAlertDesc')}</Text>
                    <Text fontSize="2xs" color="gray.500" mt={1}>{t('yesterday')}</Text>
                  </Box>
                </>
              ) : (
                <Box p={3} textAlign="center">
                  <Text fontSize="sm">{t('loginToView')}</Text>
                </Box>
              )}
            </VStack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
      
      {/* Settings Drawer */}
      <Drawer placement="right" onClose={onSettingsClose} isOpen={isSettingsOpen}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerHeader borderBottomWidth="1px" fontSize="md" py={3}>{t('settings')}</DrawerHeader>
          <DrawerBody>
            <VStack align="stretch" spacing={3}>
              <Box p={3} shadow="sm" borderWidth="1px" borderRadius="md" bg="white">
                <Text fontWeight="bold" fontSize="sm" mb={2}>
                  <HStack>
                    <FaLanguage />
                    <Text>{t('language')}</Text>
                  </HStack>
                </Text>
                <Divider mb={2} />
                <VStack align="stretch" spacing={2}>
                  {Object.entries(availableLanguages).map(([langCode, langName]) => (
                    <Button 
                      key={langCode}
                      size="sm" 
                      variant={language === langCode ? "solid" : "outline"}
                      colorScheme="green"
                      onClick={() => changeLanguage(langCode)}
                      justifyContent="flex-start"
                      w="100%"
                      leftIcon={language === langCode ? <Box w="2px" h="10px" bg="white" /> : null}
                    >
                      {t(langCode.toLowerCase())}
                    </Button>
                  ))}
                </VStack>
              </Box>
            </VStack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Box>
  );
};

export default MobileHeader;